import { render, staticRenderFns } from "./closing-update-completion-list.vue?vue&type=template&id=6a3650d5&scoped=true&"
import script from "./closing-update-completion-list.vue?vue&type=script&lang=js&"
export * from "./closing-update-completion-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3650d5",
  null
  
)

export default component.exports